export const LOADING = 'usage/LOADING';
export const GET_USAGE = 'usage/GET_USAGE';
export const ADD_NEW_USAGE = 'usage/ADD_NEW_USAGE';